import { Card, Checkbox } from "antd";
import React from "react";
import dayjs from "dayjs";
import { CheckboxChangeEvent } from "antd/es/checkbox";

interface SlotCardProps {
  slot: any;
  selectedSlot: any;
  handleSlotChange: (slot: any) => void;
}
const SlotCard: React.FC<SlotCardProps> = ({
  handleSlotChange,
  selectedSlot,
  slot,
}) => {
  return (
    <Card
      hoverable
      style={{
        borderRadius: 12,
        textAlign: "center",
        padding: "16px",
        position: "relative",
      }}
      onClick={() => handleSlotChange(slot)}
    >
      <Checkbox
        checked={selectedSlot === slot}
        onChange={(e: CheckboxChangeEvent) => {
          e.stopPropagation();
          handleSlotChange(slot);
        }}
        style={{ position: "absolute", top: 12, right: 12 }}
      />

      <div style={{ fontSize: 18, fontWeight: 600 }}>
        {dayjs(slot.start).format("hh:mm A")}
      </div>
      <div style={{ margin: "4px 0", color: "#888" }}>to</div>
      <div style={{ fontSize: 18, fontWeight: 600 }}>
        {dayjs(slot.end).format("hh:mm A")}
      </div>
    </Card>
  );
};

export default SlotCard;
